export const toygulova = {
    id: "toygulova",
    name: { ru: "Тойгулова Динара Баймухановна", kz: "Тойғұлова Динара Баймұханқызы" },
    position: { ru: "Врач-стоматолог", kz: "Дәрігер-стоматолог" },
    department: "specialists",
    image: "/team_photoes/new/toygulova.png",
    experience: {
      ru: "13 лет",
      kz: "13 жыл"
    },
    education: {
      ru: `Западно-Казахстанская медицинская академия им. Марата Оспанова, г. Актобе
Окончила интернатуру по стоматологии в 2008 году`,
      kz: `Марат Оспанов атындағы Батыс Қазақстан медицина академиясы, Ақтөбе қаласы
2008 жылы стоматология бойынша интернатураны бітірді`
    },
    specialization: {
      ru: `Актуальные проблемы терапевтической стоматологии
Детская стоматология
Эстетическая реставрация зубов`,
      kz: `Терапевтикалық тіс дәрігерлігінің өзекті мәселелері
Балалар тіс дәрігерлігі
Тістерді эстетикалық реставрациялау`
    },
        work: {
    ru: `• 2008–2010 — Врач-стоматолог-терапевт, ТОО «Басар», г. Кокшетау
• 2010–2013 — Врач-стоматолог, ИП им. Мухангалиева, г. Уральск
• 2017–2021 — Врач-стоматолог, Физкультурно-оздоровительный диспансер, Спортивный медицинский центр, г. Актобе
• 2022–2025 — Врач-стоматолог, Стоматология «M32», г. Астана, а также в г. Актобе
• 2023 — Повышение квалификации: мастер-классы и курсы по реставрации постоянных и детских зубов
• 2023–по настоящее время — Врач-стоматолог, Спортивный медицинский центр, г. Астана`,
    kz: `• 2008–2010 — Терапевт-тіс дәрігері, «Басар» ЖШС, Көкшетау қ.
• 2010–2013 — Тіс дәрігері, Муханғалиев атындағы ЖК, Орал қ.
• 2017–2021 — Тіс дәрігері, Дене шынықтыру-сауықтыру диспансері, Спорттық медициналық орталық, Ақтөбе қ.
• 2022–2025 — Тіс дәрігері, «M32» стоматологиясы, Астана қ., сондай-ақ Ақтөбе қ.
• 2023 — Біліктілікті арттыру: тұрақты және балалар тістерін қалпына келтіру бойынша мастер-кластар мен курстар
• 2023–қазіргі уақытқа дейін — Тіс дәрігері, Спорттық медициналық орталық, Астана қ.`,
  },
certificates: {
    ru: `• Работа в сфере спортивной медицины — ТОО "Арасан-Актобе"`,
    kz: `• Спорт медицинасы саласындағы жұмыс — "Арасан-Ақтөбе" ЖШС`,
  }
  };
